<template>
    <v-app-bar :clipped-left="$vuetify.breakpoint.lgAndUp" app :color="color" dark dense>
        <v-app-bar-nav-icon @click.stop="$emit('input', !value)"></v-app-bar-nav-icon>
        <v-toolbar-title class="tit tit--xs">ebook 관리자</v-toolbar-title>
        <v-text-field v-if="false" flat solo-inverted hide-details prepend-inner-icon="mdi-magnify" label="Search" class="hidden-sm-and-down" />
        <v-spacer />
    </v-app-bar>
</template>

<script>
export default {
    props: {
        value: { type: Boolean, default: null },
        color: { type: String, default: "primary" }
    },
    computed: {
        title(){
            return `${process.env.VUE_APP_PROJECT_NAME_KO}`;
        }
    }
}
</script>
